const { Button } = window.Edocat.Components;

import Input from './Input';
import Modal from '../Modal';

import { highlightErrors, onSubmitSuccess, onSubmitError, setReadyToSubmit } from '../../actions/login';
import { validateForm } from '../../utils/formData';

class Form extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onSubmit = ::this.onSubmit;
    this.form = React.createRef();

    window.onSubmitSuccess = this.onSubmitSuccess;
    window.onSubmitFailure = this.onSubmitFailure;
  }

  onSubmit(event) {
    event.preventDefault();

    const { actions, form } = this.props;
    const errors = validateForm(form);
    if (!errors.username && !errors.password) {
      actions.highlightErrors(errors);
      actions.setReadyToSubmit(true);
      this.form.current.submit();

      try {
        window.external.AutoCompleteSaveForm(this.form.current.cloneNode(true));
      } catch (e) {
        // do nothing
      }
    } else {
      actions.setReadyToSubmit(false);
      actions.highlightErrors(errors);
    }
  }

  onSubmitSuccess = () => {
    const { actions } = this.props;
    actions.onSubmitSuccess();
  };

  onSubmitFailure = () => {
    const { actions } = this.props;
    actions.onSubmitError();
  };

  render() {
    const { error, errors, processing, redirecting, readyToSubmit } = this.props;

    return (
      <form
        action={`${window.Edocat.texts.appContext}/page/dologin`}
        className="Login-Form"
        method="POST"
        onSubmit={!readyToSubmit ? this.onSubmit : null}
        ref={this.form}
        target="iframe"
      >
        <div className={`Form-Error ${error ? 'Visible' : 'Hidden'}`}>
          <p>{window.Edocat.texts['login.failed']}</p>
          <p>{window.Edocat.texts[error]}</p>
        </div>
        <div className="Form-Input">
          <Input autoFocus name="username" label={window.Edocat.texts['label.username']} />
          <Input name="password" label={window.Edocat.texts['label.password']} type="password" />
          <input
            type="text"
            className="hidden"
            name="success"
            value={`${window.Edocat.texts.appContext}/page/success`}
          />
          <input
            type="text"
            className="hidden"
            name="failure"
            value={`${window.Edocat.texts.appContext}/page/failure`}
          />
        </div>
        <div className="Form-Row Button-Row">
          <Button primary className={processing ? 'Submitting' : ''}>
            <button disabled={processing || errors.username || errors.password} type="submit">
              {window.Edocat.texts['label.login']}
            </button>
          </Button>
        </div>
        {redirecting && <Modal />}
        <div className="Copy-Info">
          <p>{window.Edocat.texts['edocat.footer.softwaredocat']}</p>
          <p>
            {window.Edocat.texts['edocat.footer.edocatlink']}{' '}
            <a href="http://www.edocat.cz" target="edocat">
              www.edocat.cz
            </a>{' '}
            {window.Edocat.texts['edocat.footer.onliolink']}{' '}
            <a href="http://www.onlio.com" target="onlio">
              www.onlio.com
            </a>
            .
          </p>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  form: state.login.form,
  errors: state.login.errors,
  error: state.login.error,
  processing: state.login.processing,
  redirecting: state.login.redirecting,
  readyToSubmit: state.login.readyToSubmit,
});

const mapDispatchToProps = dispatch => ({
  actions: redux.bindActionCreators({ highlightErrors, onSubmitSuccess, onSubmitError, setReadyToSubmit }, dispatch),
});

export default reactRedux.connect(mapStateToProps, mapDispatchToProps)(Form);
